<template>
  <NewHouseLayout>
    <div class="nh-card">
      <h2 class="nh-title">新房购置"一件事"办事指南</h2>

      <section class="nh-section">
        <h3>一、事项名称</h3>
        <p>新房购置"一件事"。</p>
      </section>

      <section class="nh-section">
        <h3>二、服务对象</h3>
        <p>个人。</p>
      </section>

      <section class="nh-section">
        <h3>三、联办事项</h3>
        <p>以下事项可在满足相关办理条件后一并联办，也可选办部分事项：</p>
        <ol class="nh-list-paren">
          <li>商品房网签合同备案（查询事项）。</li>
          <li>实测绘成果审核（查询事项）。</li>
          <li>住宅专项维修资金缴纳（办理事项）。</li>
          <li>个人身份信息核验。</li>
          <li>电表开户（查询事项）。</li>
          <li>水表开户（查询事项）。</li>
          <li>天然气表开户（办理事项）。</li>
          <li>不动产权证书办理（办理事项）。</li>
        </ol>
      </section>

      <section class="nh-section">
        <h3>四、申报条件</h3>
        <p>
          本事项适用于在江西省内购买新建商品住房（新房）的购房人，需同时满足以下基础条件。
        </p>
        <ol class="nh-list-paren">
          <li>购房主体：持有合法有效身份证件。</li>
          <li>购房行为：已与房地产开发企业签订商品房购房合同。</li>
          <li>
            身份核验：自愿通过人脸识别等方式完成个人身份信息核验，并授权相关部门使用相关电子证照。
          </li>
          <li>
            缴费及相关准备：准备足额资金用于缴纳住宅专项维修资金、税费、登记费。办理不动产权证书，应当以房屋已交付使用、完成不动产首次登记为前提。
          </li>
        </ol>
      </section>

      <section class="nh-section">
        <h3>五、办理渠道</h3>
        <p>线上：通过江西政务服务网、赣服通，进入"高效办成一件事"专区，选择"新房购置一件事"。</p>
        <p>线下：通过各地政务服务办事大厅或受委托业务网点办理。</p>
      </section>

      <section class="nh-section">
        <h3>六、办理时间</h3>
        <p>线上：全天候。</p>
        <p>线下：按各地办理窗口工作时间。</p>
      </section>

      <section class="nh-section">
        <h3>七、办理流程</h3>
        <ol class="nh-list-paren">
          <li>
            提交申请。购房人通过线上或线下办理渠道提交新房购置"一件事"申请，并授权相关部门查询核验个人身份信息等，获取相关证照材料。
          </li>
          <li>
            商品房网签合同备案查询。房地产开发企业将合同内容录入网签备案系统，并与购房者共同完成网签确认。合同签订后，由房地产开发企业办理商品房网签合同备案，购房人可同步查询备案信息。
          </li>
          <li>
            缴纳税款。购房人取得正式购房发票后，可通过线上渠道或者前往住房所在地不动产登记办税大厅办理税款缴纳。
          </li>
          <li>
            不动产权证书办理。购房人缴纳契税等相关税费后，申请办理不动产权证书。
          </li>
          <li>
            实测绘成果审核查询。房屋建成后，开发企业或测绘机构申请房产测绘成果审核，住房城乡建设部门审核完成后，购房人可查询分户房产测绘成果报告图。
          </li>
          <li>
            住宅专项维修资金缴纳。购房人通过"赣服通"平台查询待交存维修资金信息，核对确认后完成交存，并打印专用票据。
          </li>
          <li>
            电表开户信息查询。开发企业报装完成后，购房人可查询、获取户号信息。
          </li>
          <li>
            水表开户信息查询。开发企业报装完成后，购房人可查询、获取户号信息。
          </li>
          <li>
            天然气表开户。购房人可委托开发企业或直接向供气企业提交开户申请及相关资料；材料审核通过后，供气企业完成开户手续；购房人完成装修、安装燃气灶及热水器后，向供气企业申请上门安装挂表及上门验收，验收通过后通气使用。
          </li>
        </ol>
      </section>

      <section class="nh-section">
        <h3>八、申请办理材料</h3>
        <ol class="nh-list-paren">
          <li>新房购置"一件事"申请表（仅线下办理需提交，线上办理无需提交）；</li>
          <li>
            身份证件：居民身份证或户口簿或其他有效身份证明材料（可通过个人授权系统获取，无需额外提交）；
          </li>
          <li>
            房产证明材料：商品住房买卖合同（可通过个人授权系统获取，无需额外提交）。
          </li>
          <li>不动产登记申请材料：相关税费缴纳凭证。</li>
          <li>因特殊原因需提供的其他佐证材料。</li>
        </ol>
      </section>

      <section class="nh-section">
        <h3>九、是否收费</h3>
        <p>
          不动产登记收费标准：住宅：80元/件，非住宅：550元/件，小微企业（含个体工商户）免收登记费。
        </p>
      </section>

      <section class="nh-section">
        <h3>十、咨询方式</h3>
        <p>各地12345热线。</p>
      </section>

      <section class="nh-section">
        <h3>十一、办理时限</h3>
        <p>申请提交后，经审核符合相关办理条件的，自受理日起12个工作日内办结。</p>
      </section>

      <div class="nh-actions">
        <el-button
          type="danger"
          size="large"
          class="nh-enter-btn"
          @click="handleEnter"
        >
          进入办理
        </el-button>
      </div>
    </div>
  </NewHouseLayout>
</template>

<script setup>
import NewHouseLayout from './layout.vue';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getUserInfoRe } from '@/api/common';
import { setLocalStore, getLocalStore } from '@/utils/local-store';
import { ElMessage } from 'element-plus';

const router = useRouter();

const fetchUserInfo = async () => {
  try {
    const res = await getUserInfoRe();
    if (res) {
      setLocalStore('userInfo', res);
    }
  } catch (e) {
    ElMessage.error('获取用户信息失败');
  }
};

// 启动时检查 url 上的 token 参数，存入 localStorage
onMounted(() => {
  // hash 路由下 ?token=xxx 在 hash 内：#/new_house/notice?token=xxx
  // 从 hash 的 ? 之后解析；非 hash 路由退回到 search
  const hash = window.location.hash || '';
  const queryStr = hash.includes('?') ? hash.split('?')[1] : '';
  const params = new URLSearchParams(queryStr || window.location.search);
  const token = params.get('token');
  if (!token) return;

  setLocalStore('token', token);
  // 清理 url 上的 token，避免泄漏到后续路由
  const cleanedHash = hash.split('?')[0];
  const cleanedUrl = window.location.pathname + cleanedHash;
  window.history.replaceState({}, document.title, cleanedUrl);
  // 去拉一次用户信息存到 localStorage
  fetchUserInfo();
});

// 没有 token 时的授权地址（jis 房管统一认证登录）
const AUTH_LOGIN_URL =
  'https://gftjis.jxzwfww.gov.cn/jisgft/front/login.do?uuid=SFH1rp0OLaU0&gotourl=https://admin.wnzhzj.com/s-pages/';

const handleEnter = () => {
  const token = getLocalStore('token');
  if (!token) {
    ElMessage.warning('请先登录授权');
    window.location.href = AUTH_LOGIN_URL;
    return;
  }
  router.push({ name: 'newHouseMyList' });
};
</script>

<style lang="scss" scoped>
.nh-card {
  max-width: 960px;
  margin: 16px auto 24px;
  background: #ffffff;
  border-radius: 8px;
  padding: 32px 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.nh-title {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 24px;
  text-align: left;
}

.nh-section {
  margin-bottom: 24px;

  h3 {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0 0 12px;
  }

  p {
    font-size: 14px;
    color: #4a4a4a;
    line-height: 1.8;
    margin: 0 0 8px;
    text-align: left;
  }

  ul,
  ol {
    padding-left: 20px;
    margin: 8px 0;

    li {
      font-size: 14px;
      color: #4a4a4a;
      line-height: 1.9;
      text-align: left;
    }
  }
}

.nh-list-paren {
  list-style: none;
  padding-left: 0 !important;
}

.nh-tip {
  background: #fff4f4;
  color: #bd1a2d;
  border-left: 3px solid #bd1a2d;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.7;
  margin-top: 8px;
  text-align: left;
}

.nh-footer {
  display: none;
}

.nh-actions {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0d9d9;
  display: flex;
  justify-content: center;
}

.nh-enter-btn {
  width: 360px;
  max-width: 80%;
  height: 44px;
  font-size: 16px;
  background: #bd1a2d;
  border-color: #bd1a2d;
}
</style>
